import {Configuration} from '@api';

export const apiConfiguration = new Configuration({basePath: ''});
